import script from "./SupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=05ed5b05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ed5b05"]])

export default __exports__